/* Production Environment Configuration */

module.exports = {
  ENV_NAME: 'production',
  APP_TEST_MODE: false,  // MUST be false in production to enable all features
  API_URL: 'https://app.integrafms.com/api',
  ADMIN_CORNER_URL: 'https://admin.integrafms.com/admin',
  FM_SPACES_BASE_URL: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  STATIC_FILES_DIR: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  ASSET_FILES_DIR: '/src/asset/'
}



// WEBPACK FOOTER //
// ./src/config/env.production.js